import { useEffect, useRef } from 'react';

const userActionEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];


export const useInactiveTimeout = (callback: (...props: any[]) => void, delay: number) =>
{
    useEffect(() =>
    {
        if (!delay) return;

        let timeout: number | null = null;

        timeout = window.setTimeout(callback, delay);

        const resetTimeout = () =>
        {
            if (timeout) clearTimeout(timeout);
            timeout = window.setTimeout(callback, delay);
        };

        for (const event of userActionEvents) {
            document.addEventListener(event, resetTimeout);
        }

        return () =>
        {
            if (timeout) clearTimeout(timeout);

            for (const event of userActionEvents) {
                document.removeEventListener(event, resetTimeout);
            }
        };

    }, [delay, callback]);
};

/**
 * der Callback wird aufgerufen wenn sich callback und delay (in ms) nicht ändert
 *
 */
export function useInactiveInterval(callback: (...props: any[]) => void, delay: number | null)
{
    useEffect(() =>
    {
        if (delay === null || delay <= 0) {
            return;
        }
        const id = setInterval(() =>
        {
            callback();
        }, delay, {});

        return () =>
        {
            clearInterval(id);
        };
    }, [delay, callback]);
}


export function useInterval(callback: (...props: any[]) => void, delay: number | null)
{
    const savedCallback = useRef(callback);
    useEffect(() =>
    {
        savedCallback.current = callback;
    }, [callback]);

    useEffect(() =>
    {
        if (delay === null || delay <= 0) {
            return;
        }
        const id = setInterval(() =>
        {
            savedCallback.current();
        }, delay, {});

        return () =>
        {
            clearInterval(id);
        };
    }, [delay]);

}

export const convertMSinMin = (ms: number) => ms * 60000;
